import { createReducer, on } from '@ngrx/store';
import { FEATURE_FLAGS_AUTH_FEATURE_KEY, IFeatureFlagsAuthState } from '@redngapps/feature-flags/data-access';

import { login, loginFailure, loginSuccess, logout, logoutFailure, logoutSuccess } from './feature-flags-auth.actions';

export { FEATURE_FLAGS_AUTH_FEATURE_KEY };

export const initialFeatureFlagsAuthState: IFeatureFlagsAuthState = {
  pending: false,
  loggedIn: false,
  user: null,
  accessToken: null,
  permissions: null,
  error: null,
};

export const featureFlagsAuthReducer = createReducer(
  initialFeatureFlagsAuthState,

  on(login, (state): IFeatureFlagsAuthState => ({ ...state, pending: true, error: null })),
  on(
    loginSuccess,
    (state, { session, permissions }): IFeatureFlagsAuthState => ({
      ...state,
      pending: false,
      loggedIn: true,
      user: session.user,
      accessToken: session.accessToken,
      permissions,
      error: null,
    }),
  ),
  on(loginFailure, (state, { error }): IFeatureFlagsAuthState => ({ ...state, pending: false, error })),

  on(logout, (state): IFeatureFlagsAuthState => ({ ...state, pending: true })),
  on(
    logoutSuccess,
    (state): IFeatureFlagsAuthState => ({
      ...state,
      pending: false,
      loggedIn: false,
      user: null,
      accessToken: null,
      permissions: null,
    }),
  ),
  on(logoutFailure, (state): IFeatureFlagsAuthState => ({ ...state, pending: false })),
);
